/**
 * Consistency · ordbildens två färgzoner och dess bredd i mobil
 *
 * INGEN SCROLLSTYRD RÖRELSE. Filen höll fram till 2026-08-27 en klistrad hero
 * som skalades med scrollen. Alexander tog bort den: den hackade. Orsaken var
 * uppmätt och inte gissad. rita() gjorde så här i VARJE bildruta:
 *
 *   läs    hero.getBoundingClientRect() och hero.offsetHeight
 *   skriv  lager.style.transform, lager.style.opacity, ordbild transform
 *   läs    ordbild.getBoundingClientRect() och nästa sektions rect
 *   skriv  --con-ordbild-grans
 *
 * Läs, skriv, läs igen tvingar fram en synkron layoutberäkning mitt i
 * bildrutan. Lägg aldrig tillbaka något scrollstyrt här utan att mäta
 * bildrutorna först.
 *
 * Det som är kvar är två mätningar, båda vid laddning och resize, aldrig
 * under scroll:
 *
 * 1. GRÄNSEN. Namnet bakom motivet ligger halvt på sidans off-white och halvt
 *    på sektionen under, som är ett steg mörkare. Med en enda färg försvann
 *    den nedre delen helt. Därför ritas den i två lager med var sin ton, och
 *    gränsen läggs där sektionen under börjar.
 *
 * 2. BREDDEN. Ordets bredd per grad beror på vilket teckensnitt som faktiskt
 *    ligger på plats, så ett vw-mått räcker inte. Bredden mäts på den riktiga
 *    texten och graden räknas fram ur den.
 *
 * ORDBILDEN VISAS INTE I MOBIL sedan 2026-08-31 (Alexander): gränsen mellan
 * de två tonerna landar mitt i bokstäverna i stående format och läses som ett
 * fel. Skriptet mäter därför ingenting när elementet är dolt, i stället för
 * att räkna på en låda som är noll pixlar bred.
 */

(function () {
  'use strict';

  function start() {
    var hero = document.querySelector('.con-hero');
    if (!hero) return;
    var lager = hero.querySelector('.con-hero__lager');
    var ordbild = hero.querySelector('.con-hero__ordbild');
    var sektionEfter = document.querySelector('.con-hero-section + .shopify-section');

    // Städa bort inline-stil som den gamla scrolleffekten kan ha lämnat kvar
    // i en flik som stod öppen över bytet.
    if (lager) {
      lager.style.removeProperty('transform');
      lager.style.removeProperty('opacity');
    }
    if (ordbild) {
      ordbild.style.removeProperty('transform');
    }

    if (!ordbild) return;

    // Dela ordbilden i två lager med samma text. Det undre lagret klipps så
    // att bara den del som ligger mot den mörkare ytan syns.
    if (!ordbild.querySelector('.con-hero__ordbild-ljus')) {
      var text = ordbild.textContent.trim();
      ordbild.textContent = '';
      var mork = document.createElement('span');
      mork.className = 'con-hero__ordbild-mork';
      mork.textContent = text;
      var ljus = document.createElement('span');
      ljus.className = 'con-hero__ordbild-ljus';
      ljus.textContent = text;
      ordbild.appendChild(mork);
      ordbild.appendChild(ljus);
      ordbild.setAttribute('data-tvalager', '1');
    }

    // ---- 1. Graden ----
    // Ordbilden är dold i mobil, så där finns inget att mäta. I desktop
    // gäller CSS-värdet, och en grad som skriptet satt i en smalare vy måste
    // bort när fönstret dras ut igen.
    function passaBredd() {
      ordbild.style.removeProperty('--con-ordbild-storlek');
    }

    // ---- 2. Gränsen mellan de två tonerna ----
    // Gränsen = där sektionen under börjar, räknat i pixlar från ordbildens
    // egen överkant. Båda läses i samma andetag och ingenting skrivs emellan,
    // så det blir en layout och inte två.
    function matGrans() {
      if (!sektionEfter) return;
      var o = ordbild.getBoundingClientRect();
      if (!o.height) return; // dold i mobil, ingenting att dela
      var n = sektionEfter.getBoundingClientRect();
      var gr = Math.round(n.top - o.top);
      if (gr < 0) gr = 0;
      if (gr > o.height) gr = Math.round(o.height);
      ordbild.style.setProperty('--con-ordbild-grans', gr + 'px');
    }

    function matAllt() {
      passaBredd();
      matGrans();
    }

    matAllt();

    // Ordbilden är display-typografi i upp till 240 px. Bredd och höjd ändras
    // när Figtree byter ut reservtypsnittet, och heros bild påverkar höjden.
    // Därför mäts om när bilder och typsnitt är på plats.
    window.addEventListener('load', matAllt, { once: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(matAllt).catch(function () {});
    }

    var vantar = false;
    window.addEventListener(
      'resize',
      function () {
        if (vantar) return;
        vantar = true;
        window.requestAnimationFrame(function () {
          vantar = false;
          matAllt();
        });
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
